const _ = require('lodash');

function StarRatingDirective() {
    return {
        restrict: 'EA',
        template: require('./star-rating.html'),
        require: 'ngModel',
        transclude: true,
        scope: {
            numberOfStars: '=',
            isReadOnly: '=',
            removeSchemaMarkup: '@'
        },
        link(scope, element, attrs, ngModelCtrl) {

            const buildRange = (numberOfStars) => {
                if (!_.isUndefined(numberOfStars)) {
                    scope.range = _.range(1, numberOfStars + 1).map((index) => {
                        return { value: index, selected: false, isHalfRating: false };
                    });
                }
            };

            buildRange(scope.numberOfStars || 5);
            scope.ctrlName = _.uniqueId('stars_');
            scope.selectedStar = null;
            scope.selected = (star) => {


                const rating = parseInt((Math.round(star * 2) / 2).toFixed(1));

                if (!scope.isReadOnly) {
                    ngModelCtrl.$setViewValue(rating);
                }

                _.forEach(scope.range, (option) => { option.selected = false; }); // clear all

                const match = _.find(scope.range, { value: rating });

                if (match) match.selected = true;

                if (star % 1 !== 0) {
                    match.isHalfRating = true;
                }

                scope.selectedStar = rating;
            };

            ngModelCtrl.$render = () => {
                const initialRating = parseFloat((Math.round(ngModelCtrl.$viewValue * 2) / 2).toFixed(2));
                const selectedStar = _.find(scope.range, { value: initialRating || (initialRating - 0.5) });

                if (!!selectedStar) selectedStar.selected = true;

                scope.selectedStar = initialRating;
            };

            ngModelCtrl.$formatters.push((value) => { // Required to detect state changes when value is modified outside
                if (!_.isUndefined(value)) {
                    buildRange(scope.numberOfStars);
                    value = parseFloat((Math.round(value * 2) / 2).toFixed(2));
                    scope.selected(value);
                }
                return value;

            });
        }
    };
}

module.exports = StarRatingDirective;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/star-rating/star-rating-directive.js
 **/